export default __webpack_public_path__ + "static/desk-bg-b48ca04622ea468e7e1686f465c51a56.jpg";